const vipSavingsPercent = '5'

const budgetSaverWeChooseCopy = {
  tag: 'BUDGET FRIENDLY',
  shortCopy: 'We choose the flight, you save ',
  longCopy: 'We choose the flight, you save ',
}

export { vipSavingsPercent, budgetSaverWeChooseCopy }
